import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext'; // adatta il path se serve

const Reservations = () => {
  const { user } = useAuth(); // recupera utente loggato
  const [prenotazioni, setPrenotazioni] = useState([]);

  // Simulazione fetch (in futuro puoi collegarla a Firebase)
  useEffect(() => {
    if (user) {
      // Qui simuleremo i dati, ma puoi sostituire con fetch da Firebase
      setPrenotazioni([
        {
          id: 1,
          dataPrenotazione: '2025-07-01T10:15',
          partenza: 'Milano Centrale',
          arrivo: 'Aeroporto Malpensa',
          dataPartenza: '2025-07-05T09:30',
          durataMinuti: 45,
          prezzo: '85€',
        },
        {
          id: 2,
          dataPrenotazione: '2025-06-15T16:00',
          partenza: 'Brescia',
          arrivo: 'Franciacorta Village',
          dataPartenza: '2025-06-20T14:00',
          durataMinuti: 30,
          prezzo: '60€',
        },
      ]);
    }
  }, [user]);

  const formatDateTime = dateStr => {
    const date = new Date(dateStr);
    return (
      date.toLocaleDateString('it-IT') +
      ' - ' +
      date.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
      })
    );
  };

  /*const calculateArrivo = (partenzaStr, durataMinuti) => {
    const partenza = new Date(partenzaStr);
    const arrivo = new Date(partenza.getTime() + durataMinuti * 60000);
    return formatDateTime(arrivo.toISOString());
  };*/

  return (
    <div className="mx-auto max-w-7xl px-4 py-12">
      <h1 className="mb-6 text-3xl font-bold text-gray-900">Le tue prenotazioni</h1>

      {prenotazioni.length === 0 ? (
        <p className="text-gray-600">Non hai ancora effettuato prenotazioni.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full rounded bg-white text-sm shadow">
            <thead className="bg-gray-100 text-left uppercase text-gray-700">
              <tr>
                <th className="p-3">Prenotazione</th>
                <th className="p-3">Partenza</th>
                {/*<th className="p-3">Arrivo (stimato)</th>*/}
                <th className="p-3">Da</th>
                <th className="p-3">A</th>
                <th className="p-3">Prezzo</th>
              </tr>
            </thead>
            <tbody>
              {prenotazioni.map(p => (
                <tr key={p.id} className="border-t text-gray-800">
                  <td className="p-3">{formatDateTime(p.dataPrenotazione)}</td>
                  <td className="p-3">{formatDateTime(p.dataPartenza)}</td>
                  {/*<td className="p-3">{calculateArrivo(p.dataPartenza, p.durataMinuti)}</td>*/}
                  <td className="p-3">{p.partenza}</td>
                  <td className="p-3">{p.arrivo}</td>
                  <td className="p-3">{p.prezzo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Reservations;
